// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Portfolio benchmark (Compare) — aligned with dashboard / widget tokens */

.compare-page {
    padding-bottom: 48px;
}

.compare-hero {
    margin: 0 0 28px;
    padding: 22px 24px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(165deg, rgba(58, 58, 58, 0.92) 0%, rgba(34, 34, 34, 0.98) 100%);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
}

.compare-hero__title {
    margin: 0 0 10px;
    font-size: clamp(1.35rem, 2.5vw, 1.75rem);
    font-weight: 600;
    letter-spacing: -0.02em;
    color: rgb(245, 245, 245);
}

.compare-hero__lead {
    margin: 0 0 8px;
    font-size: 0.92rem;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.55);
    max-width: 62ch;
}

.compare-hero__note {
    margin: 0;
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.85);
}

.compare-panel {
    margin-bottom: 32px;
    padding: 22px 24px 24px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(180deg, rgba(52, 52, 52, 0.95) 0%, rgba(38, 38, 38, 0.98) 100%);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}

.compare-panel__title {
    margin: 0 0 18px;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);
}

.compare-slots {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 14px;
}

.compare-slot {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 0;
}

.compare-slot__label {
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.42);
}

.compare-slot__select {
    width: 100%;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.25);
    color: rgb(230, 230, 230);
    font-size: 0.88rem;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.compare-slot__select:hover,
.compare-slot__select:focus {
    border-color: rgba(192, 159, 83, 0.45);
    outline: none;
}

.compare-slot__select:focus {
    box-shadow: 0 0 0 2px rgba(192, 159, 83, 0.2);
}

.compare-chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.compare-chips__label {
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.35);
    margin-right: 4px;
}

.compare-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 4px 4px 12px;
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.88);
    background: rgba(192, 159, 83, 0.18);
    border: 1px solid rgba(192, 159, 83, 0.35);
    max-width: 100%;
}

.compare-chip__name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.compare-chip__remove {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 50%;
    font-size: 1.15rem;
    line-height: 1;
    color: rgba(255, 255, 255, 0.65);
    background: rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition:
        background 0.15s ease,
        color 0.15s ease;
}

.compare-chip__remove:hover {
    color: rgb(255, 255, 255);
    background: rgba(180, 70, 65, 0.55);
}

.compare-chip__remove:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.85);
    outline-offset: 2px;
}

.compare-actions {
    margin-top: 20px;
}

.compare-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 22px;
    border-radius: 10px;
    font-size: 0.88rem;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
}

.compare-btn--with-icon {
    gap: 10px;
}

.compare-btn__icon {
    flex-shrink: 0;
    display: block;
    opacity: 0.92;
}

.compare-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.compare-btn--primary {
    color: rgb(34, 34, 34);
    background: linear-gradient(180deg, rgb(218, 190, 120) 0%, rgb(192, 159, 83) 100%);
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.compare-btn--primary:hover:not(:disabled) {
    filter: brightness(1.06);
}

.compare-btn--secondary {
    color: rgba(255, 255, 255, 0.92);
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.14);
}

.compare-btn--secondary:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(192, 159, 83, 0.4);
}

.compare-results__head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.compare-results__title {
    margin: 0;
    font-size: 1.05rem;
    font-weight: 600;
    color: rgb(240, 240, 240);
}

.compare-section-title {
    margin: 28px 0 14px;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);
}

.compare-section-title:first-of-type {
    margin-top: 0;
}

.compare-summary-grid {
    display: grid;
    gap: 16px;
}

.compare-card {
    position: relative;
    overflow: hidden;
    padding: 20px 18px 22px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(165deg, rgba(58, 58, 58, 0.92) 0%, rgba(34, 34, 34, 1) 100%);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.22);
    text-align: left;
}

.compare-card__accent {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
        90deg,
        rgba(192, 159, 83, 0.25),
        rgba(218, 190, 120, 0.9),
        rgba(192, 159, 83, 0.25)
    );
}

.compare-card__head {
    margin-bottom: 14px;
}

.compare-card__name {
    margin: 0 0 6px;
    font-size: 1.05rem;
    font-weight: 600;
    color: rgb(245, 245, 245);
    word-break: break-word;
}

.compare-card__total {
    margin: 0 0 4px;
    font-size: 0.82rem;
    color: rgba(192, 159, 83, 0.9);
    font-variant-numeric: tabular-nums;
}

.compare-card__meta {
    margin: 0;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.42);
}

.compare-card__stats {
    margin: 0;
    display: grid;
    gap: 8px;
}

.compare-stat {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    padding: 8px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    font-size: 0.8rem;
}

.compare-stat:first-of-type {
    border-top: none;
    padding-top: 0;
}

.compare-stat dt {
    margin: 0;
    color: rgba(255, 255, 255, 0.45);
    font-weight: 500;
}

.compare-stat dd {
    margin: 0;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: rgba(255, 255, 255, 0.82);
}

.compare-stat dd.compare-stat--strong {
    color: rgba(170, 220, 155, 0.95);
}

.compare-table-wrap {
    overflow-x: auto;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.2);
}

.compare-table {
    width: 100%;
    min-width: 720px;
    border-collapse: collapse;
    font-size: 0.82rem;
}

.compare-table th,
.compare-table td {
    padding: 12px 14px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.compare-table th {
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.4);
    background: rgba(0, 0, 0, 0.25);
}

.compare-table tbody tr:hover {
    background: rgba(255, 255, 255, 0.04);
}

.compare-table__domain {
    font-weight: 600;
    color: rgb(240, 240, 240);
    max-width: 200px;
    word-break: break-word;
}

.compare-pill {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 999px;
    font-weight: 600;
    font-size: 0.78rem;
    font-variant-numeric: tabular-nums;
}

.compare-pill--pos {
    color: rgba(180, 230, 170, 0.95);
    background: rgba(90, 140, 80, 0.25);
    border: 1px solid rgba(120, 170, 100, 0.35);
}

.compare-pill--neg {
    color: rgba(255, 190, 180, 0.95);
    background: rgba(160, 70, 65, 0.22);
    border: 1px solid rgba(190, 90, 85, 0.35);
}

.compare-device-grid {
    display: grid;
    gap: 16px;
}

.compare-device-card {
    padding: 18px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.22);
}

.compare-device-card__title {
    margin: 0 0 12px;
    font-size: 0.9rem;
    font-weight: 600;
    color: rgb(235, 235, 235);
    word-break: break-word;
}

.compare-device-bar {
    display: flex;
    flex-direction: row;
    height: 12px;
    border-radius: 999px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.06);
}

.compare-device-bar__seg {
    min-width: 0;
    height: 100%;
    transition: width 0.35s ease;
}

.compare-device-bar__seg--mobile {
    background: linear-gradient(90deg, rgba(105, 158, 170, 0.85), rgba(130, 185, 198, 0.75));
}

.compare-device-bar__seg--tablet {
    background: linear-gradient(90deg, rgba(192, 159, 83, 0.75), rgba(218, 190, 120, 0.65));
}

.compare-device-bar__seg--desktop {
    background: linear-gradient(90deg, rgba(120, 120, 145, 0.85), rgba(160, 160, 185, 0.7));
}

.compare-device-legend {
    margin: 12px 0 0;
    padding: 0;
    list-style: none;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.5);
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.compare-device-legend__swatch {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 3px;
    margin-right: 6px;
    vertical-align: middle;
}

.compare-interaction-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 14px;
}

.compare-interaction-card {
    padding: 16px 16px 18px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(180deg, rgba(48, 48, 48, 0.95) 0%, rgba(32, 32, 32, 0.98) 100%);
}

.compare-interaction-card h4 {
    margin: 0 0 12px;
    font-size: 0.88rem;
    font-weight: 600;
    color: rgb(238, 238, 238);
    word-break: break-word;
}

.compare-interaction-list {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 0.8rem;
}

.compare-interaction-list li {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.45);
}

.compare-interaction-list li:first-child {
    border-top: none;
    padding-top: 0;
}

.compare-interaction-list li span:last-child {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: rgba(255, 255, 255, 0.88);
}

.compare-empty {
    padding: 28px 22px;
    border-radius: 12px;
    border: 1px dashed rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.15);
    text-align: center;
}

.compare-empty p {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.45);
}

@media screen and (max-width: 768px) {
    .compare-results__head {
        flex-direction: column;
        align-items: stretch;
    }

    .compare-btn {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Reports/Style.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,2FAA2F;IAC3F,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,2FAA2F;IAC3F,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,wDAAwD;AAC5D;;AAEA;;IAEI,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,oCAAoC;IACpC,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,8BAA8B;IAC9B,eAAe;IACf;;wBAEoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,2EAA2E;AAC/E;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kFAAkF;IAClF,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,wFAAwF;IACxF,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX;;;;;KAKC;AACL;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;IACT,cAAc;IACd,+CAA+C;IAC/C,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,2CAA2C;AAC/C;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,2FAA2F;AAC/F;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,+CAA+C;IAC/C,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* Portfolio benchmark (Compare) — aligned with dashboard / widget tokens */\n\n.compare-page {\n    padding-bottom: 48px;\n}\n\n.compare-hero {\n    margin: 0 0 28px;\n    padding: 22px 24px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(165deg, rgba(58, 58, 58, 0.92) 0%, rgba(34, 34, 34, 0.98) 100%);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);\n}\n\n.compare-hero__title {\n    margin: 0 0 10px;\n    font-size: clamp(1.35rem, 2.5vw, 1.75rem);\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    color: rgb(245, 245, 245);\n}\n\n.compare-hero__lead {\n    margin: 0 0 8px;\n    font-size: 0.92rem;\n    line-height: 1.55;\n    color: rgba(255, 255, 255, 0.55);\n    max-width: 62ch;\n}\n\n.compare-hero__note {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.85);\n}\n\n.compare-panel {\n    margin-bottom: 32px;\n    padding: 22px 24px 24px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(180deg, rgba(52, 52, 52, 0.95) 0%, rgba(38, 38, 38, 0.98) 100%);\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);\n}\n\n.compare-panel__title {\n    margin: 0 0 18px;\n    font-size: 0.7rem;\n    font-weight: 600;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.38);\n}\n\n.compare-slots {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 14px;\n}\n\n.compare-slot {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin: 0;\n}\n\n.compare-slot__label {\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.42);\n}\n\n.compare-slot__select {\n    width: 100%;\n    padding: 12px 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    background: rgba(0, 0, 0, 0.25);\n    color: rgb(230, 230, 230);\n    font-size: 0.88rem;\n    cursor: pointer;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.compare-slot__select:hover,\n.compare-slot__select:focus {\n    border-color: rgba(192, 159, 83, 0.45);\n    outline: none;\n}\n\n.compare-slot__select:focus {\n    box-shadow: 0 0 0 2px rgba(192, 159, 83, 0.2);\n}\n\n.compare-chips {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.compare-chips__label {\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.35);\n    margin-right: 4px;\n}\n\n.compare-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 4px 4px 12px;\n    border-radius: 999px;\n    font-size: 0.78rem;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.88);\n    background: rgba(192, 159, 83, 0.18);\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    max-width: 100%;\n}\n\n.compare-chip__name {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.compare-chip__remove {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    margin: 0;\n    padding: 0;\n    border: none;\n    border-radius: 50%;\n    font-size: 1.15rem;\n    line-height: 1;\n    color: rgba(255, 255, 255, 0.65);\n    background: rgba(0, 0, 0, 0.2);\n    cursor: pointer;\n    transition:\n        background 0.15s ease,\n        color 0.15s ease;\n}\n\n.compare-chip__remove:hover {\n    color: rgb(255, 255, 255);\n    background: rgba(180, 70, 65, 0.55);\n}\n\n.compare-chip__remove:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.85);\n    outline-offset: 2px;\n}\n\n.compare-actions {\n    margin-top: 20px;\n}\n\n.compare-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px 22px;\n    border-radius: 10px;\n    font-size: 0.88rem;\n    font-weight: 600;\n    cursor: pointer;\n    border: 1px solid transparent;\n    transition: background 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;\n}\n\n.compare-btn--with-icon {\n    gap: 10px;\n}\n\n.compare-btn__icon {\n    flex-shrink: 0;\n    display: block;\n    opacity: 0.92;\n}\n\n.compare-btn:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n.compare-btn--primary {\n    color: rgb(34, 34, 34);\n    background: linear-gradient(180deg, rgb(218, 190, 120) 0%, rgb(192, 159, 83) 100%);\n    border-color: rgba(255, 255, 255, 0.12);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n.compare-btn--primary:hover:not(:disabled) {\n    filter: brightness(1.06);\n}\n\n.compare-btn--secondary {\n    color: rgba(255, 255, 255, 0.92);\n    background: rgba(255, 255, 255, 0.08);\n    border-color: rgba(255, 255, 255, 0.14);\n}\n\n.compare-btn--secondary:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.12);\n    border-color: rgba(192, 159, 83, 0.4);\n}\n\n.compare-results__head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.compare-results__title {\n    margin: 0;\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: rgb(240, 240, 240);\n}\n\n.compare-section-title {\n    margin: 28px 0 14px;\n    font-size: 0.7rem;\n    font-weight: 600;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.38);\n}\n\n.compare-section-title:first-of-type {\n    margin-top: 0;\n}\n\n.compare-summary-grid {\n    display: grid;\n    gap: 16px;\n}\n\n.compare-card {\n    position: relative;\n    overflow: hidden;\n    padding: 20px 18px 22px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(165deg, rgba(58, 58, 58, 0.92) 0%, rgba(34, 34, 34, 1) 100%);\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.22);\n    text-align: left;\n}\n\n.compare-card__accent {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(\n        90deg,\n        rgba(192, 159, 83, 0.25),\n        rgba(218, 190, 120, 0.9),\n        rgba(192, 159, 83, 0.25)\n    );\n}\n\n.compare-card__head {\n    margin-bottom: 14px;\n}\n\n.compare-card__name {\n    margin: 0 0 6px;\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: rgb(245, 245, 245);\n    word-break: break-word;\n}\n\n.compare-card__total {\n    margin: 0 0 4px;\n    font-size: 0.82rem;\n    color: rgba(192, 159, 83, 0.9);\n    font-variant-numeric: tabular-nums;\n}\n\n.compare-card__meta {\n    margin: 0;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.42);\n}\n\n.compare-card__stats {\n    margin: 0;\n    display: grid;\n    gap: 8px;\n}\n\n.compare-stat {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 12px;\n    padding: 8px 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    font-size: 0.8rem;\n}\n\n.compare-stat:first-of-type {\n    border-top: none;\n    padding-top: 0;\n}\n\n.compare-stat dt {\n    margin: 0;\n    color: rgba(255, 255, 255, 0.45);\n    font-weight: 500;\n}\n\n.compare-stat dd {\n    margin: 0;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n    color: rgba(255, 255, 255, 0.82);\n}\n\n.compare-stat dd.compare-stat--strong {\n    color: rgba(170, 220, 155, 0.95);\n}\n\n.compare-table-wrap {\n    overflow-x: auto;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.compare-table {\n    width: 100%;\n    min-width: 720px;\n    border-collapse: collapse;\n    font-size: 0.82rem;\n}\n\n.compare-table th,\n.compare-table td {\n    padding: 12px 14px;\n    text-align: left;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.compare-table th {\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.4);\n    background: rgba(0, 0, 0, 0.25);\n}\n\n.compare-table tbody tr:hover {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.compare-table__domain {\n    font-weight: 600;\n    color: rgb(240, 240, 240);\n    max-width: 200px;\n    word-break: break-word;\n}\n\n.compare-pill {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-weight: 600;\n    font-size: 0.78rem;\n    font-variant-numeric: tabular-nums;\n}\n\n.compare-pill--pos {\n    color: rgba(180, 230, 170, 0.95);\n    background: rgba(90, 140, 80, 0.25);\n    border: 1px solid rgba(120, 170, 100, 0.35);\n}\n\n.compare-pill--neg {\n    color: rgba(255, 190, 180, 0.95);\n    background: rgba(160, 70, 65, 0.22);\n    border: 1px solid rgba(190, 90, 85, 0.35);\n}\n\n.compare-device-grid {\n    display: grid;\n    gap: 16px;\n}\n\n.compare-device-card {\n    padding: 18px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.22);\n}\n\n.compare-device-card__title {\n    margin: 0 0 12px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: rgb(235, 235, 235);\n    word-break: break-word;\n}\n\n.compare-device-bar {\n    display: flex;\n    flex-direction: row;\n    height: 12px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.compare-device-bar__seg {\n    min-width: 0;\n    height: 100%;\n    transition: width 0.35s ease;\n}\n\n.compare-device-bar__seg--mobile {\n    background: linear-gradient(90deg, rgba(105, 158, 170, 0.85), rgba(130, 185, 198, 0.75));\n}\n\n.compare-device-bar__seg--tablet {\n    background: linear-gradient(90deg, rgba(192, 159, 83, 0.75), rgba(218, 190, 120, 0.65));\n}\n\n.compare-device-bar__seg--desktop {\n    background: linear-gradient(90deg, rgba(120, 120, 145, 0.85), rgba(160, 160, 185, 0.7));\n}\n\n.compare-device-legend {\n    margin: 12px 0 0;\n    padding: 0;\n    list-style: none;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.5);\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.compare-device-legend__swatch {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 3px;\n    margin-right: 6px;\n    vertical-align: middle;\n}\n\n.compare-interaction-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    gap: 14px;\n}\n\n.compare-interaction-card {\n    padding: 16px 16px 18px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(180deg, rgba(48, 48, 48, 0.95) 0%, rgba(32, 32, 32, 0.98) 100%);\n}\n\n.compare-interaction-card h4 {\n    margin: 0 0 12px;\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: rgb(238, 238, 238);\n    word-break: break-word;\n}\n\n.compare-interaction-list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    font-size: 0.8rem;\n}\n\n.compare-interaction-list li {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 8px 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    color: rgba(255, 255, 255, 0.45);\n}\n\n.compare-interaction-list li:first-child {\n    border-top: none;\n    padding-top: 0;\n}\n\n.compare-interaction-list li span:last-child {\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n    color: rgba(255, 255, 255, 0.88);\n}\n\n.compare-empty {\n    padding: 28px 22px;\n    border-radius: 12px;\n    border: 1px dashed rgba(255, 255, 255, 0.12);\n    background: rgba(0, 0, 0, 0.15);\n    text-align: center;\n}\n\n.compare-empty p {\n    margin: 0;\n    font-size: 0.9rem;\n    line-height: 1.5;\n    color: rgba(255, 255, 255, 0.45);\n}\n\n@media screen and (max-width: 768px) {\n    .compare-results__head {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .compare-btn {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
